"use strict";
/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigService = void 0;
var ConfigService = /** @class */ (function () {
    function ConfigService() {
        this.values = {};
        this.loadFromGlobal('userId');
        this.loadFromGlobal('urlsrc');
        this.loadFromGlobal('directEdit');
        this.loadFromGlobal('permissions');
        this.loadFromGlobal('instanceId');
    }
    ConfigService.prototype.loadFromGlobal = function (key) {
        // @ts-ignore
        this.values[key] = window['officeonline_' + key];
    };
    ConfigService.prototype.update = function (key, value) {
        this.values[key] = value;
    };
    ConfigService.prototype.get = function (key) {
        if (typeof this.values[key] === 'undefined') {
            this.loadFromGlobal(key);
        }
        return this.values[key];
    };
    return ConfigService;
}());
exports.ConfigService = ConfigService;
var Config = new ConfigService();
exports.default = Config;
